import { Link } from "react-router-dom";
import { fullColor } from "@/mocks/manga";

const banner =
  "https://readdy.ai/api/search-image?query=Dreamy%20romance%20manga%20full%20color%20art%20of%20a%20young%20couple%20in%20a%20garden%20of%20blooming%20roses%2C%20vivid%20rose%20pink%20and%20warm%20gold%20palette%2C%20soft%20sunlight%2C%20delicate%20petals%20floating%2C%20detailed%20colorful%20illustration%2C%20rich%20saturated%20yet%20gentle%20mood%2C%20high%20quality%20digital%20art%2C%20landscape%20composition&width=1200&height=800&seq=fullcolor-banner&orientation=landscape";

export default function ColorShowcase() {
  return (
    <section className="bg-primary-100/60 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2">
          <div className="order-2 lg:order-1">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50 px-4 py-1.5 text-xs font-semibold text-primary-700">
              <i className="ri-magic-line text-sm"></i>
              全彩珍藏版
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              甜蜜惩罚漫画全彩版本
            </h2>
            <p className="mt-4 text-sm leading-7 text-foreground-700 md:text-base md:leading-8">
              我们把「初遇之章」「告白之章」「终章」等名场面以全彩形式重新收录，
              每一处眼神、每一缕光影都被赋予更细腻的色彩，让甜蜜的心动更具感染力。
              全彩章节在阅读目录中单独归类，方便喜欢彩色画面的读者一键直达。
            </p>

            <ul className="mt-6 space-y-3">
              {fullColor.map((c) => (
                <li key={c.id}>
                  <Link
                    to={`/read/${c.id}`}
                    className="group flex items-center gap-3 rounded-xl bg-background-50/70 px-4 py-3 transition-colors hover:bg-background-50"
                  >
                    <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                      <i className="ri-palette-line"></i>
                    </span>
                    <span className="text-sm font-semibold text-foreground-900 group-hover:text-primary-700">
                      {c.title}
                    </span>
                    <i className="ml-auto ri-arrow-right-s-line text-foreground-400"></i>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="order-1 lg:order-2">
            <div className="overflow-hidden rounded-2xl shadow-lg ring-1 ring-background-200/70">
              <img src={banner} alt="甜蜜惩罚漫画全彩珍藏版本插画" className="aspect-[3/2] w-full object-cover object-top" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}